import { render } from "./HelloWorld.vue?vue&type=template&id=09ac189f&scoped=true&xmlns%3Ael-icon=http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=09ac189f&scoped=true&lang=css"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ac189f"]])

export default __exports__